var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "#E3E4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.7077 20.917H25.291C24.1318 20.9205 23.021 21.3825 22.2012 22.2022C21.3815 23.0219 20.9195 24.1327 20.916 25.292V38.2128L26.5743 32.5545C27.4081 31.761 28.515 31.3184 29.666 31.3184C30.817 31.3184 31.924 31.761 32.7577 32.5545L36.9446 36.7647L38.2396 35.4697C39.0615 34.6524 40.1735 34.1936 41.3327 34.1936C42.4918 34.1936 43.6039 34.6524 44.4258 35.4697L50.0827 41.1295V25.292C50.0792 24.1327 49.6172 23.0219 48.7974 22.2022C47.9777 21.3825 46.8669 20.9205 45.7077 20.917Z",
    fill: "#8992B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7577 32.5545C31.924 31.7609 30.817 31.3184 29.666 31.3184C28.515 31.3184 27.4081 31.7609 26.5743 32.5545L20.916 38.2128V45.7086C20.9195 46.8679 21.3815 47.9787 22.2012 48.7984C23.021 49.6181 24.1318 50.0802 25.291 50.0836H45.7077C46.296 50.0833 46.8781 49.9643 47.4194 49.7337C47.9606 49.5032 48.4498 49.1659 48.8577 48.742L32.7577 32.5545Z",
    fill: "#202E5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M50.0834 41.1264L44.4266 35.4695C43.6046 34.6522 42.4926 34.1934 41.3334 34.1934C40.1743 34.1934 39.0623 34.6522 38.2403 35.4695L36.9453 36.7645L48.8526 48.7359C49.643 47.9266 50.0849 46.8401 50.0834 45.7084V41.1264Z",
    fill: "#D0D4E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicPlaceholder);
export default __webpack_public_path__ + "static/media/ClinicPlaceholder.dbc6d1922690fc7a5cfbe74d2f32fac3.svg";
export { ForwardRef as ReactComponent };